import styled from "styled-components";

export const SelectContainer = styled.div`
  display: flex;
  position: relative;
  margin-right: 10px;
`;

export const ContentContainer = styled.div`
  display: flex;
  cursor: pointer;
  min-width: 50px;
  padding: 8px 10px;
  border-radius: 5px;
  align-items: center;
  flex-direction: row;
  background-color: white;
  border: 1px #cccccc solid;
  &:hover {
    border: 1px rgba(0, 0, 0, 0.23) solid;
  }
`;

export const SelectOptionContainer = styled.div`
  top: 60px;
  right: 0px;
  z-index: 1;
  padding: 8px 10px;
  position: absolute;
  border-radius: 12px;
  background-color: white;
  border: 2px #961bed solid;
  background-color: white;
`;

export const SelectOptionInner = styled.div`
  width: 120px;
  height: auto;
  display: flex;
  flex-direction: column;
`;

export const LangItem = styled.div`
  margin-left: 12px;
`;
